import { defineStore } from 'pinia';
import { useMilkomedaWSCBridge } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBridge';

export const useFarmingMilkomedaWSCBridge = defineStore('farmingMilkomedaWSCBridge', () => {
  const milkomedaWSCBridge = useMilkomedaWSCBridge();

  return {
    ...milkomedaWSCBridge,
  };
});
